module.exports = __webpack_public_path__ + "static/media/alucio_logo.b3217d40.png";